import { versionUtils } from '@src/shared';

type SettingsOptions = {
  DEBUG: boolean;
};

type SettingsAuth = {
  JWT: {
    USER_FIELD: string;
    USERNAME_FIELD: string;
    PASSWORD_FIELD: string;
    ACCESS_TOKEN_FIELD: string;
    REFRESH_TOKEN_FIELD: string;
    AUTH_DOMAIN: string;
    TOKEN_2FA_ENROLLMENT_URL: string;
    TOKEN_2FA_VERIFY_URL: string;
    TOKEN_CREATE_URL: string;
    TOKEN_VERIFY_URL: string;
    TOKEN_REFRESH_URL: string;
    IMPERSONATION_EXCHANGE_URL: string;
    EXPIRED_BUFFER: number;
  };
};

type SettingsClients = {
  origin: {
    baseURL: string;
  };
};

class Settings {
  DEBUG: boolean;
  AUTH: SettingsAuth;
  CLIENTS: SettingsClients;

  constructor({ DEBUG }: SettingsOptions) {
    // Main
    this.DEBUG = DEBUG;

    // Authentification
    this.AUTH = {
      JWT: {
        USER_FIELD: 'user',
        USERNAME_FIELD: 'email',
        PASSWORD_FIELD: 'password',
        ACCESS_TOKEN_FIELD: 'access',
        REFRESH_TOKEN_FIELD: 'refresh',
        AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
        TOKEN_2FA_ENROLLMENT_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/jwt/token/2fa/enrollment/`,
        TOKEN_2FA_VERIFY_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/jwt/token/2fa/verify/`,
        TOKEN_CREATE_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/jwt/token/create/`,
        TOKEN_VERIFY_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/jwt/token/verify/`,
        TOKEN_REFRESH_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/jwt/token/refresh/`,
        IMPERSONATION_EXCHANGE_URL: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/impersonation/exchange/`,
        EXPIRED_BUFFER: 1000 * 60 * 5, // 5 minutes
      },
    };

    this.CLIENTS = {
      origin: {
        baseURL: `${import.meta.env.VITE_API_DOMAIN}/api/v1`,
      },
    };
  }

  init() {
    const version = versionUtils.getAppVersion();
    console.info(`Init | App - ${version}`);

    if (this.DEBUG) {
      console.info('Init | Settings - Development.');
    } else {
      console.info('Init | Settings - Production.');
    }
  }
}

function getSettings() {
  if (import.meta.env.MODE === 'production') {
    return new Settings({ DEBUG: false });
  }
  return new Settings({ DEBUG: true });
}

const settings = getSettings();

export default settings;
